export default "__VITE_ASSET__Cd$TNw1W__"